// extracted by mini-css-extract-plugin
module.exports = {"map":"PopupCard_map__1llrP","wrapper":"PopupCard_wrapper__1q2UG"};